const izmirTheme = require('./izmir.js');
const istanbulTheme = require('./istanbul.js');
const ankaraTheme = require('./ankara.js');

const themes = {
  izmir: izmirTheme,
  istanbul: istanbulTheme,
  ankara: ankaraTheme
};

function getTheme(cityId) {
  return themes[cityId] || themes.izmir;
}

function listThemes() {
  return Object.values(themes).map(t => ({
    id: t.id,
    name: t.name,
    subtitle: t.subtitle,
    icon: t.icon,
    bgGradient: t.bgGradient
  }));
}

module.exports = {
  themes,
  getTheme,
  listThemes
};
